module.exports = "<div class=\"ui-grid-cell-contents\">\n\t<a class=\"jf-link\" href\n\t   ng-click=\"appScope.GroupForm.onNameClick(row.entity)\">{{row.entity.permissionName}}</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./states/admin/security/groups/permission.name.template.html
// module id = 305
// module chunks = 0